import React, { useContext } from "react";
import { FcGoogle } from "react-icons/fc";
import Wosenderabout from "../../../../images/LandingPageImage/wosender_about_us__1x.webp";
import "../designcss/Wosenderaboutenable.css";
import { Link } from "react-router-dom";
import MyContext from "../../../../MyContext";

const Wosenderaboutenable = () => {
  const { openFreeTrialModal } = useContext(MyContext)
  return (
    <>
      <div className="about-hero-container">
        <div className="leftsidecontent">
          <span className="businessgrow">Enabling Business to grow</span>
          <span className="usingwhatsapp">smarter using WhatsApp</span>
          <span className="marketingservice">marketing services</span>

          <p className="paracontent">
            We enable small and medium-sized businesses to become smarter by
            reshaping their communication to their customers over WhatsApp.
          </p>

          <div className="buttons">
             <Link to="/login" className="text-decoration-none">
                      
            <button className="googlebtn">
              <FcGoogle /> Start With Google
            </button>
            </Link>
            <button onClick={openFreeTrialModal} className="demobtn">Book a Demo</button>
          </div>
        </div>

        <div className="rightsideimg">
          <img src={Wosenderabout} alt="" className="homescreen" />
        </div>
      </div>
    </>
  );
};

export default Wosenderaboutenable;
